import type { DashboardAnalytics } from "@/modules/dashboard/domain/repo/analytics";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type Period = "day" | "week" | "month";

export type { DashboardAnalytics };

export const dashboardApi = {
  async getAnalytics(period: Period = "week"): Promise<DashboardAnalytics> {
    return fetcher.get<DashboardAnalytics>(
      `${config.apiUrl}/dashboard/analytics?period=${period}`,
    );
  },
};
